/* Native controls continue to work after Shopify replaces section HTML. */
(() => {
  if (window.__trimdEditorReady) return;
  window.__trimdEditorReady = true;
  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const details = target.matches('details') ? target : target.closest('details');
    if (details && details.closest('.td')) details.open = true;
  });
})();
